import { render, staticRenderFns } from "./newContact.vue?vue&type=template&id=6abbe947&scoped=true&"
import script from "./newContact.vue?vue&type=script&lang=js&"
export * from "./newContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abbe947",
  null
  
)

export default component.exports